import { Navbar, Footer } from '@/components/feature';

export default function RequestQuote() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20">
        <section className="w-full bg-background-50 py-20 md:py-32">
          <div className="container-content text-center">
            <h1 className="font-heading text-display-lg text-foreground-950 mb-4">Request a Quote</h1>
            <p className="text-body-lg text-foreground-600 max-w-xl mx-auto">
              Tell us about your space and we will send a transparent, no-hidden-fee quote within four hours.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}